module.exports = __webpack_public_path__ + "static/media/timelapse.1b953989.mp4";